import React from 'react';
import Hero from './ui/Hero.js';
import image3 from './../assets/images/image3.png';

const partnerBenefits = [
    {
        title: "EXPAND",
        description: "Add library automation to the institutions you already serve."
    },
    {
        title: "EARN",
        description: "Build predictable annual business through hosting, subscriptions and related services."
    },
    {
        title: "GROW",
        description: "Offer additional technology services to your existing customer base."
    },
    {
        title: "BRAND",
        description: "Offer library technology under your own brand with a customized website & white-label solution."
    },
    {
        title: "SIMPLIFY",
        description: "Start offering library technology without investing in servers, infrastructure or developing your own LMS."
    }
];

const partnerCategories = [
    {
        title: "Book and Journal Vendors",
        description: "Extend your relationships with libraries by offering library management software."
    },
    {
        title: "Educational ERP Providers",
        description: "Complement your campus ERP solutions with library automation."
    },
    {
        title: "RFID and Library Hardware Partners",
        description: "Combine hardware projects with Koha software hosting and integration."
    },
    {
        title: "Library Consultants and ILS Trainers",
        description: "Offer clients a ready-to-use library management platform alongside your services."
    },
    {
        title: "Campus IT and Education Software Companies",
        description: "Expand your education technology portfolio with a managed library solution."
    }
];

const BuisnessAssociates = () => {

    const headingStyle = {
        fontSize: "clamp(28px, 3vw, 38px)",
        fontWeight: "700",
        lineHeight: "1.25",
        color: "var(--text-color)",
        marginBottom: "30px"
    };

    const gradientText = {
        background: "var(--primary-gradient-100)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    };

    return (
        <div style={{ paddingBottom: "30px" }}>

            {/* Existing Business Associates Hero */}
              <Hero className='' img={image3} buttonText="Become a Business Associate ">
                <h2 style={{
                    background: "var(--primary-gradient-100)",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    marginBottom: "20px"
                }}>
                    Grow Your Business with Library Technology
                </h2>

                <p style={{
                    fontSize: "18px",
                    fontWeight: "400",
                    color: "var(--text-color)",
                    lineHeight: "24px",
                    marginBottom: "30px"
                }}>

                    <span style={{
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "30px"
                    }}>
                        "Become a LibCloud Business Associate"
                    </span>

                    <br /><br />
                     Expand your service portfolio with pre-hosted Koha Library Management System and an optional Koha mobile application. We manage the cloud infrastructure and technical operations, so you can focus on acquiring clients, strengthening relationships and growing your business.
                  
                </p>

            </Hero>



            {/* ORIGINAL SECTION - PRESERVED */}
            {/*
<div className='sizedbox mt-5'>
                <h2 style={{ color: "var(--text-color)" }}>Who Can Benefit with&nbsp;
                    <span
                        style={{
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        }}>
                        Libcloud</span>?</h2>
                <p style={{ fontWeight: "400", fontSize: "20px", lineHeight: "30px", color: "var(--text-color)", marginTop: "-15px" }}>Designed for businesses, not individual libraries, to deliver Koha LMS solutions globally.</p>
                <div className='mt-3 row g-2'>
                    {
                        whoCanAssociate.map((item, index) => (
                            <div className='col-12 col-md-4 text-center p-2 align-items-stretch' >
                                <div
                                    style={{
                                        boxShadow: "0px 4px 5px 0px #00000033",
                                        padding: "20px",
                                        borderRadius: "15px",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <img className='mt-2 w-100' src={item.image} alt={item.title}></img>
                                    <h4 className='mt-4 text-center' style={{ fontSize: "24px", fontWeight: "400", color: "var(--text-color)" }}>
                                        {item.title}
                                    </h4>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
              <BusinessBenefits title="Why Add Library Technology to Your Business Portfolio?" list={benefitsOfPartnering} />
            */}

            {/*  Partner Programme Section */}
            <section
                style={{
                    background: "linear-gradient(120deg, #f0f4ff 0%, #ffffff 50%, #fff0f7 100%)",
                    padding: "65px 0",
                    marginTop: "30px"
                }}
            >

                <div className="sizedbox">

                    <div className="row g-4 g-lg-5">

                        {/* LEFT COLUMN */}
                        <div className="col-12 col-lg-6">

                            <p style={{
                                color: "#2156a5",
                                fontSize: "13px",
                                fontWeight: "700",
                                letterSpacing: "2px",
                                marginBottom: "18px"
                            }}>
                                PARTNER PROGRAMME
                            </p>

                            <h2 style={headingStyle}>
                                Why Add Library Technology
                                <span style={gradientText}>
                                    {" "}to Your Portfolio?
                                </span>
                            </h2>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                                marginTop: "88px"
                            }}>

                                {partnerBenefits.map((item, index) => (

                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: "16px",
                                            background: "#ffffff",
                                            padding: "20px",
                                            borderRadius: "12px",
                                            border: "1px solid #dce7ff",
                                            boxShadow: "0 3px 10px rgba(50, 70, 120, 0.06)",
                                            height: "100%",
                                        minHeight: "106px",
                                            }}
                                    >

                                        {/* Benefit */}
                                        <div style={{ minWidth: 0 }}>

                                            <h4 style={{
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                color: "var(--text-color)",
                                                marginBottom: "8px"
                                            }}>
                                                {item.title}
                                            </h4>

                                            <p style={{
                                                fontSize: "16px",
                                                lineHeight: "1.6",
                                                color: "var(--text-color)",
                                                marginBottom: 0,
                                                textAlign: "left"
                                            }}>
                                                {item.description}
                                            </p>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        </div>


                        {/* RIGHT COLUMN */}
                        <div className="col-12 col-lg-6">

                            <p style={{
                                color: "#2156a5",
                                fontSize: "13px",
                                fontWeight: "700",
                                letterSpacing: "2px",
                                marginBottom: "18px"
                            }}>
                                WHO THIS IS FOR
                            </p>

                            <h2 style={headingStyle}>
                                Who Can Become a
                                <span style={gradientText}>
                                    {" "}Business Associate?
                                </span>
                            </h2>

                            <p style={{
                                fontSize: "17px",
                                lineHeight: "1.7",
                                color: "var(--text-color)",
                                marginBottom: "30px",
                                textAlign: "left"
                            }}>
                                If you already work with educational institutions,
                                LibCloud can help you add library technology to
                                your existing services.
                            </p>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px"
                            }}>

                                {partnerCategories.map((category, index) => (

                                    <div
                                        key={index}
                                        style={{
                                           display: "flex",
    alignItems: "flex-start",
    gap: "16px",
    background: "linear-gradient(135deg, #f0eaff 0%, #ffe8f1 100%)",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid #e4d8ff",
    boxShadow: "0 3px 10px rgba(50, 70, 120, 0.06)",
    height: "100%",
    minHeight: "106px",
                                            }}
                                    >

                                        <div style={{ minWidth: 0 }}>

                                            <h4 style={{
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                color: "var(--text-color)",
                                                marginBottom: "8px"
                                            }}>
                                                {category.title}
                                            </h4>

                                            <p style={{
                                                fontSize: "16px",
                                                lineHeight: "1.6",
                                                color: "var(--text-color)",
                                                marginBottom: 0,
                                                textAlign: "left"
                                            }}>
                                                {category.description}
                                            </p>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    );
};

export default BuisnessAssociates;
